export * from './referenzen-hochgeladen.interface';
